import { render, staticRenderFns } from "./event_invite_overview.vue?vue&type=template&id=b242406c&"
import script from "./event_invite_overview.vue?vue&type=script&lang=js&"
export * from "./event_invite_overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports